module.exports = __webpack_public_path__ + "img/m-nex32-menu-desktop.c2de0346.png";